var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('myCampaigns')}}),_c('v-container',[_c('campaign-table-card',{attrs:{"item-route-name":"sale-management-campaign-order","campaigns":_vm.myCampaigns},on:{"select-campaign":_vm.selectCampaign}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }